import React, { FormEvent, useContext } from 'react';

import { Login } from '../Api/Login';
import Button from '../Form/Button/Button';
import MaterialInput from '../Form/MaterialInput/MaterialInput';
import ResetPassword from '../ResetPassword/ResetPassword';
import { FilterContext } from '../Context/FilterContext';

import './LoginForm.scss';

const LoginForm: React.FunctionComponent = (props) => {
    const [errorMessage, updateErrormesage] = React.useState('');
    const [wrongCredentials, setWrongCredentials] = React.useState(false);
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [loading, updateLoading] = React.useState(false);
    const [resetPasswordVisible, updateResetPasswordVisible] = React.useState(false);
    const { resetAllFilters } = useContext(FilterContext);

    const onEmailChange = (e: FormEvent<HTMLInputElement>) => {
        setEmail(e.currentTarget.value);
    };
    const onPasswordChange = (e: FormEvent<HTMLInputElement>) => {
        setPassword(e.currentTarget.value);
    };
    const showResetPasswordForm = () => {
        updateResetPasswordVisible(true);
        updateErrormesage('');
        setWrongCredentials(false);
    };
    const hideResetPasswordForm = () => {
        updateResetPasswordVisible(false);
    };

    const onSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        updateLoading(true);
        Login(
            { email, password },
            () => {
                resetAllFilters();
                updateLoading(false);
                window.location.reload();
            },
            () => {
                setWrongCredentials(true);
                updateLoading(false);
            },
            (errorMessageFromServer: string) => {
                updateLoading(false);
                updateErrormesage(errorMessageFromServer);
            },
            (errorMessageFromServer: string) => {
                updateLoading(false);
                updateErrormesage(errorMessageFromServer);
            },
        );
    };
    if (resetPasswordVisible === true) {
        return (
            <>
                <ResetPassword />
                <div
                    className="login-form__forgot-password login-form__forgot-password--back"
                    onClick={hideResetPasswordForm}
                >
                    <a onClick={hideResetPasswordForm}>Zurück zum Login</a>
                </div>
            </>
        );
    }

    return (
        <>
            <form className="login-form" method="POST" onSubmit={onSubmit}>
                <MaterialInput
                    name="email"
                    type="email"
                    label="E-Mail Adresse"
                    value={email}
                    autoComplete="email"
                    onChange={onEmailChange}
                />
                <MaterialInput
                    name="password"
                    type="password"
                    label="Passwort"
                    value={password}
                    autoComplete="password"
                    onChange={onPasswordChange}
                />
                <div className="login-form__forgot-password">
                    <a onClick={showResetPasswordForm}>Passwort vergessen?</a>
                </div>
                {errorMessage !== '' ? <div className="login-form__errors">{errorMessage}</div> : null}
                {wrongCredentials === true ? (
                    <p className="login-form__errors">
                        Diese Zugangsdaten konnten keinem Benutzer zugeordnet werden. <br />
                        Haben Sie Ihr <a onClick={showResetPasswordForm}>Passwort vergessen</a>?
                    </p>
                ) : null}
                <Button primary={true} type="submit" disabled={loading}>
                    Anmelden
                </Button>
            </form>
        </>
    );
};

export default LoginForm;
